import { Controller } from "stimulus"

/**
 * Volunteer-pool search for the shift roster page. Fetches
 * server-rendered result rows (with Fill / Add-as-alternate buttons and
 * eligibility warnings) from
 * VolunteerManagement::VolunteerSearchesController.
 *
 * Data attributes:
 *   - data-volunteer-pool-search-url: nested volunteer_searches index URL
 *
 * Targets (Stimulus 1.x syntax: data-target="volunteer-pool-search.name"):
 *   - searchInput: text input for the query
 *   - results: dropdown container for server-rendered results
 */
export default class extends Controller {
  static targets = ["searchInput", "results"]

  connect() {
    this.resultsTarget.classList.add("hidden")
    this._preventEnterSubmit = (e) => {
      if (e.key === "Enter") { e.preventDefault() }
    }
    this.searchInputTarget.addEventListener("keydown", this._preventEnterSubmit)
  }

  disconnect() {
    clearTimeout(this.searchTimeout)
    if (this.abortController) { this.abortController.abort() }
    if (this._preventEnterSubmit) {
      this.searchInputTarget.removeEventListener("keydown", this._preventEnterSubmit)
    }
  }

  search(e) {
    if (e.key === "Enter") { return }
    if (e.key === "Escape") {
      this.resultsTarget.classList.add("hidden")
      return
    }

    clearTimeout(this.searchTimeout)
    const query = this.searchInputTarget.value.trim()

    if (query.length < 3) {
      this.resultsTarget.classList.add("hidden")
      return
    }

    this.searchTimeout = setTimeout(() => {
      // Abort any in-flight request so a slow response for an older
      // query cannot overwrite the results of a newer one.
      if (this.abortController) { this.abortController.abort() }
      this.abortController = new AbortController()
      const url = this.data.get("url") + "?search=" + encodeURIComponent(query)
      fetch(url, { signal: this.abortController.signal })
        .then(response => response.text())
        .then(html => {
          // innerHTML used for trusted server-rendered content from Rails endpoint
          this.resultsTarget.innerHTML = html
          this.resultsTarget.classList.remove("hidden")
        })
        .catch(error => {
          if (error.name !== "AbortError") {
            console.error("Volunteer pool search error:", error)
          }
        })
    }, 300)
  }

  closeResults(e) {
    if (!this.element.contains(e.target)) {
      this.resultsTarget.classList.add("hidden")
    }
  }
}
